// extracted by mini-css-extract-plugin
export default {"formWrapper":"auth_formWrapper__Q0aWN","header":"auth_header__qcqzw","formData":"auth_formData__Tp7QE","signupBtn":"auth_signupBtn__JqO8c","loginConfirm":"auth_loginConfirm__+IMSO"};